import React, { useContext } from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import QuizQuestionSingleSelect from "./components/QuizQuestionSingleSelect";
import QuizQuestionMultipleSelect from "./components/QuizQuestionMultipleSelect";
import QuizQuestionInterstitial from "./components/QuizQuestionInterstitial";
import QuizQuestionPrioritySelect from "./components/QuizQuestionPrioritySelect";
import { QuestionType } from "../../utils/contentful";
import { QuizContext } from "../../utils/quiz";
import { getRichTextLength } from "../../components/RichText";
import { Container, Main } from "./styles";

const CHARACTER_LIMIT_NARROW = 42;
// const CHARACTER_LIMIT_WIDE = 84;

export type QuizQuestionComponentProps = {
    question?: any;
    options?: any[];
    next?: Function;
    index?: number;
    count?: number;
    quizType?: string;
    getOptions?: Function;
    isWide?: Boolean;
};

const QuizQuestion = ({ route, navigation }) => {
    const { next, getQuestion, getOptions, headerHeight } =
        useContext(QuizContext);
    const { id, index, count, quizType } = route.params;
    const question = getQuestion(id);
    let options = getOptions(id);
    let isInterstitial = false;
    let Component;

    const isWide = options.reduce((acc, option) => {
        if (acc) {
            return acc;
        }
        const length = option?.bodyRich
            ? getRichTextLength(option.bodyRich)
            : option?.body?.length;

        return (length ?? 0) >= CHARACTER_LIMIT_NARROW;
    }, false);

    switch (question.type) {
        case QuestionType.GenderIdentity:
        case QuestionType.YesOrNo:
        case QuestionType.TrueOrFalse:
        case QuestionType.FactOrMyth:
        case QuestionType.SingleSelect:
            Component = QuizQuestionSingleSelect;
            break;
        case QuestionType.MultipleSelect:
            Component = QuizQuestionMultipleSelect;
            break;
        case QuestionType.Priority:
            Component = QuizQuestionPrioritySelect;
            break;
        case QuestionType.Interstitial:
            Component = QuizQuestionInterstitial;
            isInterstitial = true;
            break;
    }

    return (
        <SafeAreaProvider>
            <Container
                isInterstitial={isInterstitial}
                style={{ paddingTop: headerHeight }}>
                <Main>
                    {Component && (
                        <Component
                            question={question}
                            options={options}
                            next={next}
                            index={index}
                            count={count}
                            getOptions={getOptions}
                            quizType={quizType}
                            isWide={isWide}
                        />
                    )}
                </Main>
            </Container>
        </SafeAreaProvider>
    );
};

export default QuizQuestion;
